import { createJsonNormalizer, createShapeNormalizer } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PACIFIC_PETITION_UPDATE_ORGANIZERS_LIST = createFcmConfig('pacific_petition_update_organizers_list', {
	normalizer: createJsonNormalizer(
		createShapeNormalizer({
			type: 'object',
			shape: {
				organizersList: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							id: { type: 'number' },
						},
					},
				},
			},
		}),
	),
	defaultValue: undefined,
});
